"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _title = _interopRequireDefault(require("./title.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var getHeadingToken = function getHeadingToken(name) {
  return function (_ref) {
    var _TOKENS$weightHeading, _TOKENS$sizeHeading, _TOKENS$lineHeight, _tokens;

    var theme = _ref.theme,
        type = _ref.type;
    var tokens = (_tokens = {}, (0, _defineProperty2.default)(_tokens, _constant2.TOKENS.weightHeading, (_TOKENS$weightHeading = {}, (0, _defineProperty2.default)(_TOKENS$weightHeading, _constant2.TITLE_TYPES.HERO_BANNER, theme.fontWeight.medium), (0, _defineProperty2.default)(_TOKENS$weightHeading, _constant2.TITLE_TYPES.H1, theme.fontWeight.medium), (0, _defineProperty2.default)(_TOKENS$weightHeading, _constant2.TITLE_TYPES.H2, theme.fontWeight.medium), (0, _defineProperty2.default)(_TOKENS$weightHeading, _constant2.TITLE_TYPES.H3, theme.fontWeight.medium), _TOKENS$weightHeading)), (0, _defineProperty2.default)(_tokens, _constant2.TOKENS.sizeHeading, (_TOKENS$sizeHeading = {}, (0, _defineProperty2.default)(_TOKENS$sizeHeading, _constant2.TITLE_TYPES.HERO_BANNER, theme.fontSize.titleLarge), (0, _defineProperty2.default)(_TOKENS$sizeHeading, _constant2.TITLE_TYPES.H1, theme.fontSize.titleMedium), (0, _defineProperty2.default)(_TOKENS$sizeHeading, _constant2.TITLE_TYPES.H2, theme.fontSize.titleNormal), (0, _defineProperty2.default)(_TOKENS$sizeHeading, _constant2.TITLE_TYPES.H3, theme.fontSize.titleSmall), _TOKENS$sizeHeading)), (0, _defineProperty2.default)(_tokens, _constant2.TOKENS.lineHeight, (_TOKENS$lineHeight = {}, (0, _defineProperty2.default)(_TOKENS$lineHeight, _constant2.TITLE_TYPES.HERO_BANNER, theme.lineHeight.titleLarge), (0, _defineProperty2.default)(_TOKENS$lineHeight, _constant2.TITLE_TYPES.H1, theme.lineHeight.titleMedium), (0, _defineProperty2.default)(_TOKENS$lineHeight, _constant2.TITLE_TYPES.H2, theme.lineHeight.titleNormal), (0, _defineProperty2.default)(_TOKENS$lineHeight, _constant2.TITLE_TYPES.H3, theme.lineHeight.titleSmall), _TOKENS$lineHeight)), _tokens);
    return tokens[name][type];
  };
};

var extractMargin = function extractMargin(_ref2) {
  var marginBottom = _ref2.marginBottom,
      theme = _ref2.theme;
  return _constant.ARR_SPACING_TYPES.indexOf(marginBottom) !== -1 ? theme.space[marginBottom] : '0px';
};

var StyledHeading = (0, _styledComponents.default)(function (_ref3) {
  var type = _ref3.type,
      className = _ref3.className,
      children = _ref3.children,
      tabIndex = _ref3.tabIndex,
      customProperties = _ref3.customProperties;
  var Component = type && type === _constant2.TITLE_TYPES.HERO_BANNER ? _constant2.TITLE_TYPES.H1 : type;
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    tabIndex: tabIndex
  }, customProperties), children);
}).withConfig({
  displayName: "Title__StyledHeading",
  componentId: "sc-7301oj-0"
})(["display:block;margin:0px 0px ", ";font-family:", ";font-size:", ";font-weight:", ";text-align:", ";color:", ";line-height:", ";"], extractMargin, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
}, getHeadingToken(_constant2.TOKENS.sizeHeading), getHeadingToken(_constant2.TOKENS.weightHeading), function (_ref5) {
  var textAlign = _ref5.textAlign;
  return textAlign;
}, function (_ref6) {
  var theme = _ref6.theme,
      inverted = _ref6.inverted,
      color = _ref6.color;
  var clr = color ? theme.colors[color] : theme.colors.neutral;
  return inverted ? theme.colors.default : clr;
}, getHeadingToken(_constant2.TOKENS.lineHeight));

var limitCharacters = function limitCharacters(value) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  if (value && value.length > limit) {
    return "".concat(value.substr(0, limit), "...");
  }

  return value;
};

var Title = function Title(props) {
  var type = props.type,
      children = props.children,
      theme = props.theme,
      marginBottom = props.marginBottom,
      inverted = props.inverted,
      customProperties = props.customProperties,
      accessible = props.accessible,
      color = props.color,
      textLimit = props.textLimit,
      textAlign = props.textAlign,
      className = props.className;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledHeading, {
      type: type,
      theme: themeContext,
      textAlign: textAlign,
      marginBottom: marginBottom,
      inverted: inverted,
      color: color,
      customProperties: customProperties,
      tabIndex: tabIndex,
      className: className
    }, textLimit !== undefined && limitCharacters(children, textLimit) || children);
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Title.propTypes = _title.default.PropTypes;
Title.defaultProps = _title.default.defaultProps;
var _default = Title;
exports.default = _default;